import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";

export default function StudentLessons() {
  const [lessons, setLessons] = useState([]);
  useEffect(() => { api.get("/lessons").then(({ data }) => setLessons(data || [])).catch(() => {}); }, []);

  const now = Date.now();
  const upcoming = lessons.filter((l) => new Date(l.scheduled_at).getTime() >= now && l.status !== "cancelled");
  const past = lessons.filter((l) => new Date(l.scheduled_at).getTime() < now || l.status === "completed");

  return (
    <div className="space-y-8" data-testid="student-lessons-page">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#38BDF8] font-bold">Your sessions</div>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter mt-2">My lessons</h2>
      </div>

      <Section title="Upcoming" items={upcoming} />
      <Section title="Past" items={past} muted />
    </div>
  );
}

function Section({ title, items, muted }) {
  const statusPill = (l) => {
    if (l.status === "completed") return { label: "Completed", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-400/40" };
    if (l.status === "cancelled") return { label: "Cancelled", cls: "bg-red-500/15 text-red-300 border-red-400/40" };
    return null;
  };
  return (
    <div>
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] font-bold mb-3">{title}</div>
      {items.length === 0 ? (
        <div className="border border-dashed border-white/10 p-8 text-[#A3A3A3] text-sm">Nothing here yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((l) => {
            const pill = statusPill(l);
            return (
              <Link key={l.id} to={`/student/lessons/${l.id}`} className={`card-surface p-5 ${muted ? "opacity-80" : ""}`} data-testid={`lesson-${l.id}`}>
                <div className="text-[10px] uppercase tracking-widest text-[#38BDF8] font-bold flex items-center gap-2 flex-wrap">
                  <span>{new Date(l.scheduled_at).toLocaleString([], { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</span>
                  {pill && (
                    <span className={`px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest border ${pill.cls}`} data-testid={`lesson-status-${l.id}`}>
                      {pill.label}
                    </span>
                  )}
                </div>
                <div className={`font-display text-xl font-bold uppercase tracking-tight mt-1 ${l.status === "completed" ? "line-through decoration-emerald-300/50" : l.status === "cancelled" ? "line-through decoration-red-300/60" : ""}`}>{l.title}</div>
                <div className="text-xs text-[#A3A3A3] mt-2">{l.status} · {l.duration_mins}min</div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
